import * as React from 'react';
import { FormBanner } from '../../../components/FormBanner';
import { useFormProps } from './hooks/useFormProps';

export const BannerFormContainer: React.FC = () => {
  const props = useFormProps();

  return <FormBanner {...props} />;
};
